import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import GenericList from '@ts-core/core/components/GenericList';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';
import StudentPracticeSessionCard from '@ts-core/modules/practice/components/StudentPracticeSessionCard';
import { StudentPracticeSession } from '@ts-core/modules/practice/types';

import { useStudentPracticeSessions } from '../../hooks';

const StudentPracticeSessionsPage = () => {
  const { courseId, studentId } = useParams<{ courseId: string; studentId: string }>();
  const history = useHistory();

  const { studentPracticeSessions, loading } = useStudentPracticeSessions({ courseId, studentId });

  const handlePracticeSessionActionClick = useCallback(
    (practiceSession: StudentPracticeSession) => {
      history.push(`/${courseId}/students/${studentId}/practice/${practiceSession._id}`);
    },
    [history, courseId, studentId]
  );

  return (
    <PageContentLayout>
      <GenericList
        items={studentPracticeSessions}
        loading={loading}
        skeletonsCount={2}
        emptyMessage={'El estudiante aún no ha practicado ningún ejercicio.'}
        renderItem={(index, practiceSession) => (
          <StudentPracticeSessionCard
            key={practiceSession?._id || index}
            practiceSession={practiceSession}
            loading={loading}
            onPracticeSessionActionClick={handlePracticeSessionActionClick}
          />
        )}
      />
    </PageContentLayout>
  );
};

export default StudentPracticeSessionsPage;
